module.exports = ".jt-big {\n  margin-right: 2px; }\n\n.stats__item__line div:first-child {\n  -webkit-flex-wrap: unset;\n      -ms-flex-wrap: unset;\n          flex-wrap: unset;\n  white-space: nowrap;\n  min-width: unset; }\n\n.stats__item__line div:last-child {\n  min-width: 0; }\n\n.event__name {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden; }\n\n.event__type {\n  white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/event-item/event-item.component.scss
// module id = ./web/modern/components/common/event-item/event-item.component.scss
// module chunks = 0